import React from 'react';
import ModalFormUI from '../../../widgets/form/ModalFormUI';
import InputTextSF from '../../../widgets/form/InputTextSF';
import InputSelectSF from '../../../widgets/form/InputSelectSF';
const LeadCreateModalUI = ({
    // Modes
    context, successMsg, errorList, setErrorList, submitted,
    createLeadMode,
    // Event Handlers
    onSubmit, onCancelClick,
    // Email
    email, onEmailChange, emailError, setEmailError,
    // Name
    leadName, onLeadNameChange, leadNameError, setLeadNameError,
    // Channel
    channel, onChannelChange, channelError, setChannelError,
    // Owner User ID
    ownerUserId, onOwnerUserIdChange, ownerUserIdError, setOwnerUserIdError,
    // Support Owner User ID
    supportOwnerUserId, onSupportOwnerUserIdChange, supportOwnerUserIdError, setSupportOwnerUserIdError,
    //list
    salesChannelList,ownerUserList,supportOwnerUserList
}) => {

    return (
        <ModalFormUI
            context={context}
            titleLabel='Create lead'
            buttonLabel="Create"
            cancelLabel="Cancel"
            isOpen={createLeadMode}
            onRequestClose={onCancelClick}
            successMsg={successMsg}
            errorList={errorList}
            setErrorList={setErrorList}
            onSubmit={onSubmit}
            busy={submitted}
        >

            <InputTextSF type="text" name="email" label="Email"
                maxLength={40} required={true}
                value={email} onChange={onEmailChange}
                error={emailError} setError={setEmailError}
            />

            <InputTextSF type="text" name="name" label="Name"
                maxLength={40} required={true}
                value={leadName} onChange={onLeadNameChange}
                error={leadNameError} setError={setLeadNameError}
            />

            <InputSelectSF type='select' name='channel' required={true}
                label='Sales channel' autoFocus={true} optionList={salesChannelList}
                value={channel} onChange={onChannelChange}
                error={channelError} setError={setChannelError}
            />
            <InputSelectSF type="text" name="ownerUserId" label="Owner User ID"
                maxLength={40} required={true} optionList={ownerUserList}
                value={ownerUserId} onChange={onOwnerUserIdChange}
                error={ownerUserIdError} setError={setOwnerUserIdError}
            />

            <InputSelectSF type="text" name="supportOwnerUserId" label="Support Owner User ID"
                maxLength={40} required={true} optionList={supportOwnerUserList}
                value={supportOwnerUserId} onChange={onSupportOwnerUserIdChange}
                error={supportOwnerUserIdError} setError={setSupportOwnerUserIdError}
            />
        </ModalFormUI>
    );
};

export default LeadCreateModalUI;
